import { Button, type ButtonProps } from "@mantine/core";
import { useLocation } from "wouter";

export function LinkButton(props: { href: string } & ButtonProps) {
  const [_, setLocation] = useLocation();

  const { href, ...rest } = props;
  return (
    <Button onClick={() => setLocation(href)} {...rest}>
      {props.children}
    </Button>
  );
}
